import LengthSelectorScreen from "@dana/Components/EZID/LengthSelectorScreen";
import PhaseSelectorScreen from "@dana/Components/EZID/PhaseSelectorScreen";
import ResultScreen from "@dana/Components/EZID/ResultScreen";
import SeriesSelectorScreen from "@dana/Components/EZID/SeriesSelectorScreen";
import UJointStyleSelectorScreen from "@dana/Components/EZID/UJointStyleSelectorScreen";
import { EZIDAttributeFilter } from "@dana/Types/EZIDAttributeFilter";
import { WizardStep } from "@dana/Types/WizardStep";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { get } from "@insite/client-framework/Services/ApiService";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    LinkFieldValue,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { useEffect, useState } from "react";


const enum fields {
    // Main Page
    pageHeading = "pageHeading",
    pageSubText = "pageSubText",
    backLabel = "backLabel",
    readyShaftTypeSelectionUrl = "readyShaftTypeSelectionUrl",
    watchVideoLabel = "watchVideoLabel",
    nextLabel = "nextLabel",
    stepLabel = "stepLabel",

    // Step 1 - Select Series
    selectSeriesHeading = "selectSeriesHeading",
    seriesLabel = "seriesLabel",
    selectSeriesImage = "selectSeriesImage",
    selectSeriesImageAltText = "selectSeriesImageAltText",
    selectSeriesLeftNote = "selectSeriesLeftNote",
    selectSeriesRightNote = "selectSeriesRightNote",
    selectSeriesVideo = "selectSeriesVideo",
    selectSeriesVideoCaption = "selectSeriesVideoCaption",

    // Step 2 - Select U-Joint Style
    selectUJointStyleHeading = "selectUJointStyleHeading",
    uJointStyleLabel = "uJointStyleLabel",
    selectUJointStyleImage = "selectUJointStyleImage",
    selectUJointStyleImageAltText = "selectUJointStyleImageAltText",
    selectUJointStyleLeftNote = "selectUJointStyleLeftNote",
    selectUJointStyleRightNote = "selectUJointStyleRightNote",
    selectUJointStyleVideo = "selectUJointStyleVideo",
    selectUJointStyleVideoCaption = "selectUJointStyleVideoCaption",

    // Step 3 - Select Center of Tube/Weld Yoke to Center of Center Bearing
    selectCLYokeToCLBearingHeading = "selectCLYokeToCLBearingHeading",
    selectCLYokeToCLBearingImage = "selectCLYokeToCLBearingImage",
    selectCLYokeToCLBearingImageAltText = "selectCLYokeToCLBearingImageAltText",
    selectCLYokeToCLBearingVideo = "selectCLYokeToCLBearingVideo",
    selectCLYokeToCLBearingVideoCaption = "selectCLYokeToCLBearingVideoCaption",
    selectCLYokeToCLBearingLeftNote = "selectCLYokeToCLBearingLeftNote",
    selectCLYokeToCLBearingRightNote = "selectCLYokeToCLBearingRightNote",
    selectCLYokeToCLBearingMMLabel = "selectCLYokeToCLBearingMMLabel",
    selectCLYokeToCLBearingINLabel = "selectCLYokeToCLBearingINLabel",

    // Step 4 - Select Center of Tube/Weld Yoke to Center of Center Bearing Yoke
    selectCLYokeToCLYokeHeading = "selectCLYokeToCLYokeHeading",
    selectCLYokeToCLYokeImage = "selectCLYokeToCLYokeImage",
    selectCLYokeToCLYokeImageAltText = "selectCLYokeToCLYokeImageAltText",
    selectCLYokeToCLYokeVideo = "selectCLYokeToCLYokeVideo",
    selectCLYokeToCLYokeVideoCaption = "selectCLYokeToCLYokeVideoCaption",
    selectCLYokeToCLYokeLeftNote = "selectCLYokeToCLYokeLeftNote",
    selectCLYokeToCLYokeRightNote = "selectCLYokeToCLYokeRightNote",
    selectCLYokeToCLYokeMMLabel = "selectCLYokeToCLYokeMMLabel",
    selectCLYokeToCLYokeINLabel = "selectCLYokeToCLYokeINLabel",

    // Step 5 - Select Tube Length
    selectTubeLengthHeading = "selectTubeLengthHeading",
    selectTubeLengthImage = "selectTubeLengthImage",
    selectTubeLengthImageAltText = "selectTubeLengthImageAltText",
    selectTubeLengthMMLabel = "selectTubeLengthMMLabel",
    selectTubeLengthINLabel = "selectTubeLengthINLabel",
    selectTubeLengthLeftNote = "selectTubeLengthLeftNote",
    selectTubeLengthRightNote = "selectTubeLengthRightNote",
    selectTubeLengthVideo = "selectTubeLengthVideo",
    selectTubeLengthVideoCaption = "selectTubeLengthVideoCaption",

    // Step 6 - Select Tube Size
    selectTubeSizeHeading = "selectTubeSizeHeading",
    selectTubeSizeImage = "selectTubeSizeImage",
    selectTubeSizeImageAltText = "selectTubeSizeImageAltText",
    selectTubeSizeMMLabel = "selectTubeSizeMMLabel",
    selectTubeSizeINLabel = "selectTubeSizeINLabel",
    selectTubeSizeLeftNote = "selectTubeSizeLeftNote",
    selectTubeSizeRightNote = "selectTubeSizeRightNote",
    selectTubeSizeVideo = "selectTubeSizeVideo",
    selectTubeSizeVideoCaption = "selectTubeSizeVideoCaption",

    // Step 7 - Select Phasing
    selectPhasingHeading = "selectPhasingHeading",
    phasingLabel = "phasingLabel",
    selectPhasingImage = "selectPhasingImage",
    selectPhasingImageAltText = "selectPhasingImageAltText",
    selectPhasingLeftNote = "selectPhasingLeftNote",
    selectPhasingRightNote = "selectPhasingRightNote",
    selectPhasingVideo = "selectPhasingVideo",
    selectPhasingVideoCaption = "selectPhasingVideoCaption",

    // Result Page
    productDefaultImage = "productDefaultImage",
    productDefaultImageAltText = "productDefaultImageAltText",
    promotionalImage = "promotionalImage",
    promotionalImageAltText = "promotionalImageAltText",
    promotionalText = "promotionalText",
    promotionalURL = "promotionalURL",
    viewAdditionalDetailLabel = "viewAdditionalDetailLabel",
}

interface OwnProps extends PageProps {
    fields: {
        // Main Page
        pageHeading: string;
        pageSubText: string;
        backLabel: string;
        readyShaftTypeSelectionUrl: LinkFieldValue;
        watchVideoLabel: string;
        nextLabel: string;
        stepLabel: string;

        // Step 1 - Select Series
        selectSeriesHeading: string;
        seriesLabel: string;
        selectSeriesImage: string;
        selectSeriesImageAltText: string;
        selectSeriesLeftNote: string;
        selectSeriesRightNote: string;
        selectSeriesVideo: LinkFieldValue;
        selectSeriesVideoCaption: LinkFieldValue;

        // Step 2 - Select U-Joint Style
        selectUJointStyleHeading: string;
        uJointStyleLabel: string;
        selectUJointStyleImage: string;
        selectUJointStyleImageAltText: string;
        selectUJointStyleLeftNote: string;
        selectUJointStyleRightNote: string;
        selectUJointStyleVideo: LinkFieldValue;
        selectUJointStyleVideoCaption: LinkFieldValue;

        // Step 3 - Select Center of Tube/Weld Yoke to Center of Center Bearing
        selectCLYokeToCLBearingHeading: string;
        selectCLYokeToCLBearingImage: string;
        selectCLYokeToCLBearingImageAltText: string;
        selectCLYokeToCLBearingVideo: LinkFieldValue;
        selectCLYokeToCLBearingVideoCaption: LinkFieldValue;
        selectCLYokeToCLBearingLeftNote: string;
        selectCLYokeToCLBearingRightNote: string;
        selectCLYokeToCLBearingMMLabel: string;
        selectCLYokeToCLBearingINLabel: string;

        // Step 4 - Select Center of Tube/Weld Yoke to Center of Center Bearing Yoke
        selectCLYokeToCLYokeHeading: string;
        selectCLYokeToCLYokeImage: string;
        selectCLYokeToCLYokeImageAltText: string;
        selectCLYokeToCLYokeVideo: LinkFieldValue;
        selectCLYokeToCLYokeVideoCaption: LinkFieldValue;
        selectCLYokeToCLYokeLeftNote: string;
        selectCLYokeToCLYokeRightNote: string;
        selectCLYokeToCLYokeMMLabel: string;
        selectCLYokeToCLYokeINLabel: string;

        // Step 5 - Select Tube Length
        selectTubeLengthHeading: string;
        selectTubeLengthImage: string;
        selectTubeLengthImageAltText: string;
        selectTubeLengthMMLabel: string;
        selectTubeLengthINLabel: string;
        selectTubeLengthLeftNote: string;
        selectTubeLengthRightNote: string;
        selectTubeLengthVideo: LinkFieldValue;
        selectTubeLengthVideoCaption: LinkFieldValue;

        // Step 6 - Select Tube Size
        selectTubeSizeHeading?: string;
        selectTubeSizeImage?: string;
        selectTubeSizeImageAltText?: string;
        selectTubeSizeMMLabel?: string;
        selectTubeSizeINLabel?: string;
        selectTubeSizeLeftNote?: string;
        selectTubeSizeRightNote?: string;
        selectTubeSizeVideo?: LinkFieldValue;
        selectTubeSizeVideoCaption?: LinkFieldValue;

        // Step 7 - Select Phasing
        selectPhasingHeading?: string;
        phasingLabel?: string;
        selectPhasingImage?: string;
        selectPhasingImageAltText?: string;
        selectPhasingLeftNote?: string;
        selectPhasingRightNote?: string;
        selectPhasingVideo?: LinkFieldValue;
        selectPhasingVideoCaption?: LinkFieldValue;

        // Result Page
        productDefaultImage?: string;
        productDefaultImageAltText?: string;
        promotionalImage?: string;
        promotionalImageAltText?: string;
        promotionalText?: string;
        promotionalURL?: LinkFieldValue;
        viewAdditionalDetailLabel?: string;
    };
}

const EZIDCouplingShaftWorkflowPage = ({ id, fields }: OwnProps) => {
    const [stepStack, setStepStack] = useState<WizardStep[]>([{ main: 0 }]);
    const currentStep = stepStack[stepStack.length - 1];

    const [readyshaftCategoryId, setreadyshaftCategoryId] = useState("");
    const [spicerReadyShaftBrandId, setspicerReadyShaftBrandId] = useState("");
    const [invoiceAttributeValueId, setinvoiceAttributeValueId] = useState("");
    const [attributeFilters, setAttributeFilters] = useState<EZIDAttributeFilter[]>([]);
    const { isInShell } = useShellContext();
    const history = useHistory();
    const { url } = useGetLink(fields.readyShaftTypeSelectionUrl);

    useEffect(() => {
        const fetchFilters = async () => {
            get("/api/v1/ezid/getSpicerReadyShaftFilters?workflow=coupling-shaft").then((data: any) => {
                setreadyshaftCategoryId(data?.readyshaftCategoryId);
                setspicerReadyShaftBrandId(data?.spicerReadyShaftBrandId);
                setinvoiceAttributeValueId(data?.invoiceAttributeValueId);
                setAttributeFilters([{
                    attributeTypeName: 'Type',
                    attributeValueId: data.invoiceAttributeValueId,
                    attributeValueName: 'Coupling Shaft',
                }]);
                setStepStack(prev => [...prev, { main: 1 }]); // move to step 1 after fetching filters
            }).catch((error) => {
                console.error("Error fetching filters:", error);
            });
        }
        fetchFilters();
    }, []);

    const proceedToNextScreen = (newAttributeFilters?: EZIDAttributeFilter[], subStep?: number) => {
        if (newAttributeFilters) {
            setAttributeFilters(newAttributeFilters);
        }
        const nextStep = subStep ? { main: currentStep.main, sub: subStep } : { main: currentStep.main + 1 };
        setStepStack(prev => [...prev, nextStep]);
    };

    const proceedToPreviousScreen = (newAttributeFilters?: EZIDAttributeFilter[]) => {
        if (newAttributeFilters) {
            setAttributeFilters(newAttributeFilters);
        }

        if (currentStep.main > 1) {
            setStepStack(prev => prev.length > 1 ? prev.slice(0, -1) : prev);
        } else {
            if (!url) {
                return;
            }

            if (url.startsWith("http")) {
                if (isInShell) {
                    return;
                }
                window.location.href = url;
            } else {
                history.push(url);
            }
        }
    }

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" requireRows />
            {currentStep.main === 1 && (
                <SeriesSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectSeriesVideo}
                    caption={fields.selectSeriesVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectSeriesHeading}
                    image={fields.selectSeriesImage}
                    imageAltText={fields.selectSeriesImageAltText}
                    facetLabel={fields.seriesLabel}
                    leftNote={fields.selectSeriesLeftNote}
                    rightNote={fields.selectSeriesRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={1}
                />
            )}
            {currentStep.main === 2 && (
                <UJointStyleSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectUJointStyleVideo}
                    caption={fields.selectUJointStyleVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectUJointStyleHeading}
                    image={fields.selectUJointStyleImage}
                    imageAltText={fields.selectUJointStyleImageAltText}
                    facetLabel={fields.uJointStyleLabel}
                    leftNote={fields.selectUJointStyleLeftNote}
                    rightNote={fields.selectUJointStyleRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={2}
                />
            )}
            {currentStep.main === 3 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectCLYokeToCLBearingHeading}
                    image={fields.selectCLYokeToCLBearingImage}
                    imageAltText={fields.selectCLYokeToCLBearingImageAltText}
                    leftFacetLabel={fields.selectCLYokeToCLBearingMMLabel}
                    rightFacetLabel={fields.selectCLYokeToCLBearingINLabel}
                    leftNote={fields.selectCLYokeToCLBearingLeftNote}
                    rightNote={fields.selectCLYokeToCLBearingRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={3}
                    attributeNameInMillimeters="CL Yoke To CL Bearing (MM)"
                    attributeNameInInches="CL Yoke To CL Bearing (IN)"
                    video={fields.selectCLYokeToCLBearingVideo}
                    caption={fields.selectCLYokeToCLBearingVideoCaption}
                    watchVideoLabel={fields.watchVideoLabel}
                />
            )}
            {currentStep.main === 4 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectCLYokeToCLYokeHeading}
                    image={fields.selectCLYokeToCLYokeImage}
                    imageAltText={fields.selectCLYokeToCLYokeImageAltText}
                    leftFacetLabel={fields.selectCLYokeToCLYokeMMLabel}
                    rightFacetLabel={fields.selectCLYokeToCLYokeINLabel}
                    leftNote={fields.selectCLYokeToCLYokeLeftNote}
                    rightNote={fields.selectCLYokeToCLYokeRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={4}
                    attributeNameInMillimeters="CL Yoke To CL Yoke (MM)-COLL"
                    attributeNameInInches="CL Yoke To CL Yoke (IN)-COLL"
                    video={fields.selectCLYokeToCLYokeVideo}
                    caption={fields.selectCLYokeToCLYokeVideoCaption}
                    watchVideoLabel={fields.watchVideoLabel}
                />
            )}

            {currentStep.main === 5 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectTubeLengthHeading}
                    image={fields.selectTubeLengthImage}
                    imageAltText={fields.selectTubeLengthImageAltText}
                    leftFacetLabel={fields.selectTubeLengthMMLabel}
                    rightFacetLabel={fields.selectTubeLengthINLabel}
                    leftNote={fields.selectTubeLengthLeftNote}
                    rightNote={fields.selectTubeLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={5}
                    attributeNameInMillimeters="Tube Length (MM)"
                    attributeNameInInches="Tube Length (IN)"
                    video={fields.selectTubeLengthVideo}
                    caption={fields.selectTubeLengthVideoCaption}
                    watchVideoLabel={fields.watchVideoLabel}
                />
            )}

            {currentStep.main === 6 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectTubeSizeHeading}
                    image={fields.selectTubeSizeImage}
                    imageAltText={fields.selectTubeSizeImageAltText}
                    leftFacetLabel={fields.selectTubeSizeMMLabel}
                    rightFacetLabel={fields.selectTubeSizeINLabel}
                    leftNote={fields.selectTubeSizeLeftNote}
                    rightNote={fields.selectTubeSizeRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={6}
                    attributeNameInMillimeters="Tube Size (MM)"
                    attributeNameInInches="Tube Size (IN)"
                    video={fields.selectTubeSizeVideo}
                    caption={fields.selectTubeSizeVideoCaption}
                    watchVideoLabel={fields.watchVideoLabel}
                />
            )}
            {currentStep.main === 7 && (
                <PhaseSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectPhasingVideo}
                    caption={fields.selectPhasingVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectPhasingHeading}
                    image={fields.selectPhasingImage}
                    imageAltText={fields.selectPhasingImageAltText}
                    facetLabel={fields.phasingLabel}
                    leftNote={fields.selectPhasingLeftNote}
                    rightNote={fields.selectPhasingRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={7}
                />
            )}
            {currentStep.main === 8 && (
                <ResultScreen
                    backLabel={fields.backLabel}
                    currentAttributeFilters={attributeFilters}
                    spicerReadyShaftBrandId={spicerReadyShaftBrandId}
                    readyshaftCategoryId={readyshaftCategoryId}
                    productDefaultImage={fields.productDefaultImage}
                    productDefaultImageAltText={fields.productDefaultImageAltText}
                    promotionalImage={fields.promotionalImage}
                    promotionalImageAltText={fields.promotionalImageAltText}
                    promotionalText={fields.promotionalText}
                    promotionalURL={fields.promotionalURL}
                    viewAdditionalDetailLabel={fields.viewAdditionalDetailLabel}
                    onProceedToPreviousScreen={proceedToPreviousScreen}

                />
            )}

        </Page>
    )
};

const mainTab = {
    displayName: "Main Page",
    sortOrder: 0,
};

const selectSeriesTab = {
    displayName: "Select Series (Step 1)",
    sortOrder: 1,
};

const selectUJointStyleTab = {
    displayName: "Select U-Joint Style (Step 2)",
    sortOrder: 2,
};

const selectCLYokeToCLBearingTab = {
    displayName: "Select CL Yoke to CL Bearing (Step 3)",
    sortOrder: 3,
}

const selectCLYokeToCLYokeTab = {
    displayName: "Select CL Yoke to CL Yoke (Step 4)",
    sortOrder: 4,
};

const selectTubeLengthTab = {
    displayName: "Select Tube Length (Step 5)",
    sortOrder: 5,
};

const selectTubeSizeTab = {
    displayName: "Select Tube Size (Step 6)",
    sortOrder: 6,
};

const selectPhasingTab = {
    displayName: "Select Phasing (Step 7)",
    sortOrder: 7,
};

const resultTab = {
    displayName: "Result Page",
    sortOrder: 8,
};

const pageModule: PageModule = {
    component: EZIDCouplingShaftWorkflowPage,
    definition: {
        displayName: "Coupling Shaft Workflow Page",
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,

            // Main Page
            {
                fieldType: "Translatable",
                name: fields.pageHeading,
                editorTemplate: "TextField",
                displayName: "Page Heading",
                defaultValue: "Spicer ReadyShaft Visual Search",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.pageSubText,
                editorTemplate: "TextField",
                displayName: "Page Sub Text",
                defaultValue: "Coupling Shaft Selector",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.backLabel,
                editorTemplate: "TextField",
                displayName: "Back Button Label",
                defaultValue: "Back",
                tab: mainTab,
            },
            {
                name: fields.readyShaftTypeSelectionUrl,
                fieldType: "Translatable",
                displayName: "ReadyShaft Type Selection URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.watchVideoLabel,
                editorTemplate: "TextField",
                displayName: "Watch Video Label",
                defaultValue: "Watch The Video",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.nextLabel,
                editorTemplate: "TextField",
                displayName: "Next Button Label",
                defaultValue: "Next",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.stepLabel,
                editorTemplate: "TextField",
                displayName: "Step Label",
                defaultValue: "Step",
                tab: mainTab,
            },

            // Step 1 - Select Series
            {
                fieldType: "Translatable",
                name: fields.selectSeriesHeading,
                editorTemplate: "TextField",
                displayName: "Select Series Heading",
                defaultValue: "Select Series",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.seriesLabel,
                editorTemplate: "TextField",
                displayName: "Series Label",
                defaultValue: "Series",
                tab: selectSeriesTab,
            },
            {
                name: fields.selectSeriesImage,
                fieldType: "Translatable",
                displayName: "Select Series Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectSeriesImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Series Image Alt Text",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectSeriesLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Series Left Note",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectSeriesRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Series Right Note",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                name: fields.selectSeriesVideo,
                fieldType: "Translatable",
                displayName: "Select Series Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectSeriesTab,
            },
            {
                name: fields.selectSeriesVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Series Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectSeriesTab,
            },

            // Step 2 - Select U-Joint Style
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleHeading,
                editorTemplate: "TextField",
                displayName: "Select U-Joint Style Heading",
                defaultValue: "Select U-Joint Style",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.uJointStyleLabel,
                editorTemplate: "TextField",
                displayName: "U-Joint Style Label",
                defaultValue: "U-Joint Style",
                tab: selectUJointStyleTab,
            },
            {
                name: fields.selectUJointStyleImage,
                fieldType: "Translatable",
                displayName: "Select U-Joint Style Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleImageAltText,
                editorTemplate: "TextField",
                displayName: "Select U-Joint Style Image Alt Text",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select U-Joint Style Left Note",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select U-Joint Style Right Note",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                name: fields.selectUJointStyleVideo,
                fieldType: "Translatable",
                displayName: "Select U-Joint Style Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectUJointStyleTab,
            },
            {
                name: fields.selectUJointStyleVideoCaption,
                fieldType: "Translatable",
                displayName: "Select U-Joint Style Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectUJointStyleTab,
            },

            // Step 3 - Select Center of Tube/Weld Yoke to Center of Center Bearing
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLBearingHeading,
                editorTemplate: "TextField",
                displayName: "Select CL Yoke to CL Bearing Heading",
                defaultValue: "Select Center of Tube/Weld Yoke to Center of Center Bearing",
                tab: selectCLYokeToCLBearingTab,
            },
            {
                name: fields.selectCLYokeToCLBearingImage,
                fieldType: "Translatable",
                displayName: "Select CL Yoke to CL Bearing Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectCLYokeToCLBearingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLBearingImageAltText,
                editorTemplate: "TextField",
                displayName: "Select CL Yoke to CL Bearing Image Alt Text",
                defaultValue: "",
                tab: selectCLYokeToCLBearingTab,
            },
            {
                name: fields.selectCLYokeToCLBearingVideo,
                fieldType: "Translatable",
                displayName: "Select CL Yoke to CL Bearing Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectCLYokeToCLBearingTab,
            },
            {
                name: fields.selectCLYokeToCLBearingVideoCaption,
                fieldType: "Translatable",
                displayName: "Select CL Yoke to CL Bearing Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectCLYokeToCLBearingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLBearingLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select CL Yoke to CL Bearing Left Note",
                defaultValue: "",
                tab: selectCLYokeToCLBearingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLBearingRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select CL Yoke to CL Bearing Right Note",
                defaultValue: "",
                tab: selectCLYokeToCLBearingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLBearingMMLabel,
                editorTemplate: "TextField",
                displayName: "CL Yoke To CL Bearing (MM) Label",
                defaultValue: "CL Yoke To CL Bearing (MM)",
                tab: selectCLYokeToCLBearingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLBearingINLabel,
                editorTemplate: "TextField",
                displayName: "CL Yoke To CL Bearing (IN) Label",
                defaultValue: "CL Yoke To CL Bearing (IN)",
                tab: selectCLYokeToCLBearingTab,
            },

            // Step 4 - Select Center of Tube/Weld Yoke to Center of Center Bearing Yoke
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLYokeHeading,
                editorTemplate: "TextField",
                displayName: "Select CL Yoke to CL Yoke Heading",
                defaultValue: "Select Center of Tube/Weld Yoke to Center of Center Bearing Yoke",
                tab: selectCLYokeToCLYokeTab,
            },
            {
                name: fields.selectCLYokeToCLYokeImage,
                fieldType: "Translatable",
                displayName: "Select CL Yoke to CL Yoke Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectCLYokeToCLYokeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLYokeImageAltText,
                editorTemplate: "TextField",
                displayName: "Select CL Yoke to CL Yoke Image Alt Text",
                defaultValue: "",
                tab: selectCLYokeToCLYokeTab,
            },
            {
                name: fields.selectCLYokeToCLYokeVideo,
                fieldType: "Translatable",
                displayName: "Select CL Yoke to CL Yoke Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectCLYokeToCLYokeTab,
            },
            {
                name: fields.selectCLYokeToCLYokeVideoCaption,
                fieldType: "Translatable",
                displayName: "Select CL Yoke to CL Yoke Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectCLYokeToCLYokeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLYokeLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select CL Yoke to CL Yoke Left Note",
                defaultValue: "",
                tab: selectCLYokeToCLYokeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLYokeRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select CL Yoke to CL Yoke Right Note",
                defaultValue: "",
                tab: selectCLYokeToCLYokeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLYokeMMLabel,
                editorTemplate: "TextField",
                displayName: "CL Yoke To CL Yoke (MM) Label",
                defaultValue: "CL Yoke To CL Yoke (MM)-COLL",
                tab: selectCLYokeToCLYokeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectCLYokeToCLYokeINLabel,
                editorTemplate: "TextField",
                displayName: "CL Yoke To CL Yoke (IN) Label",
                defaultValue: "CL Yoke To CL Yoke (IN)-COLL",
                tab: selectCLYokeToCLYokeTab,
            },

            // Step 5 - Select Tube Length
            {
                fieldType: "Translatable",
                name: fields.selectTubeLengthHeading,
                editorTemplate: "TextField",
                displayName: "Select Tube Length Heading",
                defaultValue: "Select Tube Length (Weld to Weld)",
                tab: selectTubeLengthTab,
            },
            {
                name: fields.selectTubeLengthImage,
                fieldType: "Translatable",
                displayName: "Select Tube Length Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectTubeLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeLengthImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Tube Length Image Alt Text",
                defaultValue: "",
                tab: selectTubeLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeLengthLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Tube Length Left Note",
                defaultValue: "",
                tab: selectTubeLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeLengthRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Tube Length Right Note",
                defaultValue: "",
                tab: selectTubeLengthTab,
            },
            {
                name: fields.selectTubeLengthVideo,
                fieldType: "Translatable",
                displayName: "Select Tube Length Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectTubeLengthTab,
            },
            {
                name: fields.selectTubeLengthVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Tube Length Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectTubeLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeLengthMMLabel,
                editorTemplate: "TextField",
                displayName: "Tube Length (MM) Label",
                defaultValue: "Tube Length (MM)",
                tab: selectTubeLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeLengthINLabel,
                editorTemplate: "TextField",
                displayName: "Tube Length (IN) Label",
                defaultValue: "Tube Length (IN)",
                tab: selectTubeLengthTab,
            },

            // Step 6 - Select Tube Size
            {
                fieldType: "Translatable",
                name: fields.selectTubeSizeHeading,
                editorTemplate: "TextField",
                displayName: "Select Tube Size Heading",
                defaultValue: "Select Tube Diameter and Wall Thickness",
                tab: selectTubeSizeTab,
            },
            {
                name: fields.selectTubeSizeImage,
                fieldType: "Translatable",
                displayName: "Select Tube Size Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectTubeSizeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeSizeImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Tube Size Image Alt Text",
                defaultValue: "",
                tab: selectTubeSizeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeSizeLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Tube Size Left Note",
                defaultValue: "",
                tab: selectTubeSizeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeSizeRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Tube Size Right Note",
                defaultValue: "",
                tab: selectTubeSizeTab,
            },
            {
                name: fields.selectTubeSizeVideo,
                fieldType: "Translatable",
                displayName: "Select Tube Size Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectTubeSizeTab,
            },
            {
                name: fields.selectTubeSizeVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Tube Size Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectTubeSizeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeSizeMMLabel,
                editorTemplate: "TextField",
                displayName: "Tube Size (MM) Label",
                defaultValue: "Tube Size (MM)",
                tab: selectTubeSizeTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectTubeSizeINLabel,
                editorTemplate: "TextField",
                displayName: "Tube Size (IN) Label",
                defaultValue: "Tube Size (IN)",
                tab: selectTubeSizeTab,
            },

            // Step 7 - Select Phasing
            {
                fieldType: "Translatable",
                name: fields.selectPhasingHeading,
                editorTemplate: "TextField",
                displayName: "Select Phasing Heading",
                defaultValue: "Select Phasing",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.phasingLabel,
                editorTemplate: "TextField",
                displayName: "Select Phasing Label",
                defaultValue: "Phase (Yes/No)",
                tab: selectPhasingTab,
            },
            {
                name: fields.selectPhasingImage,
                fieldType: "Translatable",
                displayName: "Select Phasing Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectPhasingImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Phasing Image Alt Text",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectPhasingLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Phasing Left Note",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectPhasingRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Phasing Right Note",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                name: fields.selectPhasingVideo,
                fieldType: "Translatable",
                displayName: "Select Phasing Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectPhasingTab,
            },
            {
                name: fields.selectPhasingVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Phasing Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectPhasingTab,
            },

            // Result Page
            {
                fieldType: "Translatable",
                name: fields.productDefaultImage,
                editorTemplate: "ImagePickerField",
                displayName: "Product Default Image",
                defaultValue: "",
                tab: resultTab,
            },
            {
                fieldType: "Translatable",
                name: fields.productDefaultImageAltText,
                editorTemplate: "TextField",
                displayName: "Product Default Image Alt Text",
                defaultValue: "",
                tab: resultTab,
            },
            {
                fieldType: "Translatable",
                name: fields.promotionalImage,
                editorTemplate: "ImagePickerField",
                displayName: "Promotional Image",
                defaultValue: "",
                tab: resultTab,
            },
            {
                name: fields.promotionalImageAltText,
                fieldType: "Translatable",
                displayName: "Promotional Image Alt Text",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: resultTab,
            },
            {
                name: fields.promotionalText,
                fieldType: "Translatable",
                displayName: "Promotional Text",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: resultTab,
            },
            {
                name: fields.promotionalURL,
                fieldType: "Translatable",
                displayName: "Promotional URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: resultTab,
            },
            {
                fieldType: "Translatable",
                name: fields.viewAdditionalDetailLabel,
                editorTemplate: "TextField",
                displayName: "View Additional Detail Label",
                defaultValue: "View Additional Detail",
                tab: resultTab,
            },

        ],
    },
};

export default pageModule;
